import React from "react";
import { Grid } from "@material-ui/core";
import CcaAcademicYearInput from "components/CcaAcademicYearInput";
import CustomCcaStudentScheduleDateInput from "components/CustomCcaStudentScheduleDateInput";
import SanitizedGrid from "components/SanitizedGrid";
import { BooleanInput, FormDataConsumer, SelectInput } from "react-admin";

interface IStudentCreateCcaFixedLocationProps {
  setIdCcaAcademicYear: (value: number) => void;
  ccaAcademicYearResources: any;
  ccaIncludeDates: IIncludeDates[];
  ccaExcludeDates: IExcludeDates[];
  ccaFixedLocationDropOffs: ICcaFixedLocationDropOff[];
  ccaWaves: ICcaWave[];
  selectedSchool: ISchool | null;
}

export const StudentCreateCcaFixedLocation = ({
  setIdCcaAcademicYear,
  ccaAcademicYearResources,
  ccaIncludeDates,
  ccaExcludeDates,
  ccaFixedLocationDropOffs,
  ccaWaves,
  selectedSchool,
}: IStudentCreateCcaFixedLocationProps) => {
  return (
    <>
      <Grid item xs={4}>
        <CcaAcademicYearInput parentCallback={setIdCcaAcademicYear} />
      </Grid>

      <Grid item xs={8}></Grid>

      <Grid item xs={4}>
        <CustomCcaStudentScheduleDateInput
          source="ccaStartedAt"
          label="Start Date *"
          referenceSource={ccaAcademicYearResources}
          includeDates={ccaIncludeDates}
          excludeDates={ccaExcludeDates}
        />
      </Grid>

      <Grid item xs={5} style={{ marginTop: 20 }}>
        <BooleanInput
          source="isUseOneFixedLocation"
          label="Use One Fixed Location for All Selected Days"
          defaultValue={true}
        />
      </Grid>
      <Grid item xs={7}></Grid>

      <FormDataConsumer>
        {({ formData, ...rest }) =>
          formData.isUseOneFixedLocation && (
            <Grid item xs={4} style={{ margin: "-20px 0 10px" }}>
              <SelectInput
                source="fixedLocationId"
                choices={ccaFixedLocationDropOffs}
              />
            </Grid>
          )
        }
      </FormDataConsumer>

      <Grid item xs={3}>
        <BooleanInput
          label="Monday"
          source="isCcaMonday"
          defaultValue={false}
        />
        <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData.isCcaMonday && (
              <SanitizedGrid
                container
                spacing={2}
                style={{ margin: "-20px 0px 20px" }}
              >
                {!formData.isUseOneFixedLocation && (
                  <SelectInput
                    source="fixedLocationMondayId"
                    choices={ccaFixedLocationDropOffs}
                  />
                )}
                {selectedSchool?.isAllowParentSelectWave && (
                  <SelectInput
                    source="waveMondayId"
                    choices={ccaWaves.filter((wave: ICcaWave) => wave.isMonday)}
                  />
                )}
              </SanitizedGrid>
            )
          }
        </FormDataConsumer>
      </Grid>

      <Grid item xs={3}>
        <BooleanInput
          label="Tuesday"
          source="isCcaTuesday"
          defaultValue={false}
        />
        <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData.isCcaTuesday === true && (
              <SanitizedGrid
                container
                spacing={2}
                style={{ margin: "-20px 0px 20px" }}
              >
                {!formData.isUseOneFixedLocation && (
                  <SelectInput
                    source="fixedLocationTuesdayId"
                    choices={ccaFixedLocationDropOffs}
                  />
                )}
                {selectedSchool?.isAllowParentSelectWave && (
                  <SelectInput
                    source="waveTuesdayId"
                    choices={ccaWaves.filter((wave: ICcaWave) => wave.isTuesday)}
                  />
                )}
              </SanitizedGrid>
            )
          }
        </FormDataConsumer>
      </Grid>

      <Grid item xs={3}>
        <BooleanInput
          label="Wednesday"
          source="isCcaWednesday"
          defaultValue={false}
        />
        <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData.isCcaWednesday === true && (
              <SanitizedGrid
                container
                spacing={2}
                style={{ margin: "-20px 0px 20px" }}
              >
                {!formData.isUseOneFixedLocation && (
                  <SelectInput
                    source="fixedLocationWednesdayId"
                    choices={ccaFixedLocationDropOffs}
                  />
                )}
                {selectedSchool.isAllowParentSelectWave && (
                  <SelectInput
                    source="waveWednesdayId"
                    choices={ccaWaves.filter((wave: ICcaWave) => wave.isWednesday)}
                  />
                )}
              </SanitizedGrid>
            )
          }
        </FormDataConsumer>
      </Grid>

      <Grid item xs={3}>
        <BooleanInput
          label="Thursday"
          source="isCcaThursday"
          defaultValue={false}
        />
        <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData.isCcaThursday === true && (
              <SanitizedGrid
                container
                spacing={2}
                style={{ margin: "-20px 0px 20px" }}
              >
                {!formData.isUseOneFixedLocation && (
                  <SelectInput
                    source="fixedLocationThursdayId"
                    choices={ccaFixedLocationDropOffs}
                  />
                )}
                {selectedSchool.isAllowParentSelectWave && (
                  <SelectInput
                    source="waveThursdayId"
                    choices={ccaWaves.filter((wave: ICcaWave) => wave.isThursday)}
                  />
                )}
              </SanitizedGrid>
            )
          }
        </FormDataConsumer>
      </Grid>

      <Grid item xs={3}>
        <BooleanInput
          label="Friday"
          source="isCcaFriday"
          defaultValue={false}
        />
        <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData.isCcaFriday === true &&
            selectedSchool.isAllowParentSelectWave && (
              <SanitizedGrid
                container
                spacing={2}
                style={{ margin: "-20px 0px 20px" }}
              >
                {!formData.isUseOneFixedLocation && (
                  <SelectInput
                    source="fixedLocationFridayId"
                    choices={ccaFixedLocationDropOffs}
                  />
                )}
                {selectedSchool.isAllowParentSelectWave && (
                  <SelectInput
                    source="waveFridayId"
                    choices={ccaWaves.filter((wave: ICcaWave) => wave.isFriday)}
                  />
                )}
              </SanitizedGrid>
            )
          }
        </FormDataConsumer>
      </Grid>
    </>
  );
};
